// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountTermsOfService --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAccountTermsOfServiceFragment on OpenapiAccountTermsOfService {
    date
    ip
  }
`;

export const stripeAccountTermsOfServiceFragment: StripeAccountTermsOfServiceFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountTermsOfServiceFragmentData = {
  readonly __typename: 'OpenapiAccountTermsOfService';
  readonly date: number | null;
  readonly ip: string | null;
};

export type StripeAccountTermsOfServiceFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountTermsOfServiceFragmentPermissions = {} as const;

doc.permissions = stripeAccountTermsOfServiceFragmentPermissions;

export type StripeAccountTermsOfServiceFragmentPermissions = V1PermissionToken<
  typeof stripeAccountTermsOfServiceFragmentPermissions
>;

export type StripeAccountTermsOfServiceFragmentDocument = GraphQlDocument<
  StripeAccountTermsOfServiceFragmentData,
  StripeAccountTermsOfServiceFragmentVariables,
  StripeAccountTermsOfServiceFragmentPermissions
>;
